import { render, staticRenderFns } from "./BlogAccordion.vue?vue&type=template&id=35a5fa19&"
import script from "./BlogAccordion.vue?vue&type=script&lang=js&"
export * from "./BlogAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports